<template>
  <section class="realtors">
    <h2 class="realtors-title">{{ $t('results.realtors-title') }}</h2>
    <b-row class="justify-content-center">
      <b-col md="4" class="mb-5" v-for="r in getRealtors" :key="r.index">
        <div class="realtor-img-container">
          <img :src="r.logoUrl" :alt="r.logoAlt">
        </div>
        <h3>{{ r.name }}</h3>
        <a :href="r.link.url" target="_blank">{{ r.link.title }}</a>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Realtors',
  computed: {
    ...mapGetters(['getRealtors'])
  }
}
</script>
